































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import { BUSSINESS, BUSSINESS_SUBJECTS, BUSSINNESS_CATEGORY } from '../../../service/constant'
import {
  batchDirectPass,
  fetchJzdxTopics,
  getCurrentUserInfo,
  getTodoTaskList,
  queryGroupUser,
  startWorkflow,
  getDeletedResource,
  getDistributeResource
} from '../../../service/manage'
import { getTaskInstance } from '../../../service/platform'
import { Cache, SongGuo } from '../../../service/common'
import { FORM_ITEM_LAYOUT } from '../config/'
import { sourceDeletedColumns } from '../config/columns'
import { column, option } from '../interface/'
import { TaskInstance } from '../../platform/types/task'
import ViewAuditHistory from '../../platform/components/ViewAuditHistory.vue'

@Component({ components: { ViewAuditHistory } })
export default class TaskQueryDeleted extends Vue {
  public get dict() {
    return this.$store.state[BUSSINESS_SUBJECTS]
  }
  public get category() {
    return this.$store.state[BUSSINNESS_CATEGORY]
  }
  // 未分配资源
  private get business() {
    return this.$store.state[BUSSINESS]
  }
  private get subjects() {
    if (!this.sourceForm.business_type) return []
    return this.dict[this.sourceForm.business_type] || []
  }
  private get taskBusiness() {
    return [...this.business]
  }

  // 需要根据资源和学科获取分类
  private get sourceFormCategoryOptions() {
    var sourceData: any = []
    if (!this.sourceForm.business_type) return []
    for (var item of this.category[this.sourceForm.business_type]) {
      for (var key in item) {
        if (key == this.sourceForm.subject_id) {
          const ishas: boolean = item[key].some((item) => item.value == '')
          if (!ishas) {
            item[key].unshift({ value: '', label: '不限' })
          }
          sourceData = item[key] || []
        }
      }
    }
    return sourceData
  }

  private get sourceFormShowCategory() {
    return [6003, 6004, 7001].includes(Number(this.sourceForm.business_type))
  }
  // 未分配资源查询条件
  private get sourceFormStatusOptions(): { label: string; value: string }[] {
    if (this.sourceForm.subject_id == 801 && this.sourceForm.business_type == 6001) {
      return [{ label: '未分配', value: 'unassign' }]
    } else if (this.sourceForm.subject_id == 802 && this.sourceForm.business_type == 6002) {
      return [{ label: '未分配', value: 'unassign' }]
    } else if (this.sourceForm.business_type == 6003) {
      return [{ label: '未分配', value: 'unassign' }]
    } else {
      return [
        { value: '', label: '不限' },
        { label: '一审未分配', value: 'first_unassign' },
        { label: '二审未分配', value: 'second_unassign' }
      ]
    }
  }
  public formItemLayout = FORM_ITEM_LAYOUT
  public sourcePagination = {
    total: 0,
    current: 1,
    pageSize: 30,
    showTotal: (total) => `共 ${total} 条`
  }
  public dataSource: any[] = []
  public sourceDeletedColumns: column[] = sourceDeletedColumns

  private sourceForm: any = {
    resource_id: '',
    business_type: 0,
    subject_id: 0,
    time: ['', ''],
    status: '',
    category: ''
  }
  public async mounted() {
    // @ts-ignore
    window.batch = this
    const query = this.$route.query
    this.sourceForm.business_type = query.business_id
      ? Number(query.business_id)
      : this.business[0].value
    if (query.subject_id) {
      this.sourceForm.subject_id = Number(query.subject_id)
    }
    if (query.category) {
      this.sourceForm.category = query.category
    }
    await this.renderDeletedList(1)
  }
  @Watch('sourceForm.business_type')
  public onBussinessChange(val) {
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.sourceForm.subject_id)) {
      setTimeout(() => {
        this.sourceForm.subject_id = this.subjects[0].value
        const query = this.$route.query
        if (query.subject_id) {
          this.sourceForm.subject_id = Number(query.subject_id)
        }
      })
    }
  }

  public handleSourceTableChange(pagination) {
    this.renderDeletedList(pagination.current)
  }
  public async renderDeletedList(page_num) {
    const options = {
      subject_id: Number(this.sourceForm.subject_id),
      business_type: Number(this.sourceForm.business_type),
      start_at: this.sourceForm.time[0],
      end_at: this.sourceForm.time[1],
      status: this.sourceForm.status,
      resource_id: this.sourceForm.resource_id,
      category: this.sourceForm.category,
      page_num,
      page_size: 30
    }
    const { list, total } = await getDeletedResource(options)
    this.dataSource = list
    this.sourcePagination.total = total
    this.sourcePagination.current = page_num
  }
  public onSourceTimeChange(date, dateString) {
    this.sourceForm.time = dateString
  }
  public handleSourceFormSubmit(e) {
    this.renderDeletedList(1)
  }

  @Watch('sourceFormStatusOptions')
  private onSourceFormStatusOptionsChange() {
    // options 变化时更新默认值
    this.sourceForm.status = this.sourceFormStatusOptions[0].value
  }

  checkSubTask(text, record) {
    console.log(text, record)
  }

  private subInstanceData: TaskInstance | {} = {} // 查看审核信息-实例数据
  private showAuditHistory = false // 是否显示审核信息modal

  public async checkHistory(record: any) {
    console.log('record', record)
    let instance = (await getTaskInstance(record.instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.subInstanceData = instance
    this.showAuditHistory = true
  }
}
